/** @jsx jsx */
import { jsx } from '@emotion/react'
import { css } from '@emotion/react/macro'
import BarLoader from 'react-spinners/BarLoader'

import { baseColor } from '../../../../lib/styles/colors'
import { useStudentNetworkStatus } from '../../../../lib/clients/getStudentClientOIDC'
import DelayedRender from '../DelayedRender'
// import { useSchedulerNetworkStatus } from '../../../../lib/clients/getSchedulerClient'

// add display: flex as workaround for disappearing BarLoader problem
// https://github.com/davidhu2000/react-spinners/issues/341
// https://www.w3.org/TR/css3-grid-layout/#grid-placement-int
const barContainerCss = css`
  grid-column: 1 / -1;
  grid-row: 2;
  height: 100%;
  width: 100%;
  display: flex;
`

type LoadBarProps = {
  /** Bypasses isLoading and displays <BarLoader /> */
  persist?: boolean
}

const defaultProps: LoadBarProps = {
  persist: undefined
}

// TODO: integrate with scheduler GraphQL client
const LoadBar = ({ persist }: LoadBarProps) => {
  const { numPendingQueries: pendingStudentQueries } = useStudentNetworkStatus()
  // const { numPendingQueries: pendingSchedulerQueries } = useSchedulerNetworkStatus()
  const isLoading = pendingStudentQueries > 0

  return (
    <div css={barContainerCss}>
      {(isLoading || persist) && (
        <DelayedRender delay={50}>
          <BarLoader color={baseColor} width="100%" />
        </DelayedRender>
      )}
    </div>
  )
}

LoadBar.defaultProps = defaultProps

export default LoadBar
